module.exports = __webpack_public_path__ + "media/custom/images/img17-ccd751d6552cdc73d52fb053d45ccb44.png";